import {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'

import khetiAxiosInstance from './axios/kheti/config'

interface InterceptorsCb {
  requestInterceptorSuccessCb?: (
    config: InternalAxiosRequestConfig<any>,
  ) =>
    | InternalAxiosRequestConfig<any>
    | Promise<InternalAxiosRequestConfig<any>>
    | void
  requestInterceptorErrCb?: (error: AxiosError) => AxiosError | Promise<AxiosError> | void
  responseInterceptorSuccessCb?: (
    config: AxiosResponse<any>,
  ) => AxiosResponse<any> | Promise<AxiosResponse<any>> | void
  responseInterceptorErrCb?: (error: AxiosError) => unknown
}

export interface KhetiAxiosConfig extends InterceptorsCb {
  appCode: string
  khetiUrl: string
}

function setUpInterceptors(
  instance: AxiosInstance,
  requestInterceptorSuccessCb?: (
    config: InternalAxiosRequestConfig<any>,
  ) =>
    | InternalAxiosRequestConfig<any>
    | Promise<InternalAxiosRequestConfig<any>>
    | void,
  requestInterceptorErrCb?: (error: AxiosError) => AxiosError | Promise<AxiosError> | void,
  responseInterceptorSuccessCb?: (
    config: AxiosResponse<any>,
  ) => AxiosResponse<any> | Promise<AxiosResponse<any>> | void,
  responseInterceptorErrCb?: (error: AxiosError) => unknown,
) {
  instance.interceptors.request.use(
    config => {
      if (!requestInterceptorSuccessCb) return config
      const updatedConfig = requestInterceptorSuccessCb(config)
      return updatedConfig || config
    },
    error => {
      requestInterceptorErrCb && requestInterceptorErrCb(error)
      return Promise.reject(error)
    },
  )
  instance.interceptors.response.use(
    response => {
      if (responseInterceptorSuccessCb) {
        const interceptedResponse = responseInterceptorSuccessCb(response)
        if (interceptedResponse) return interceptedResponse
      }
      if (response.data.error == null) {
        return response
      }
      return Promise.reject(response.data.error)
    },
    error => {
      if (responseInterceptorErrCb) {
        return responseInterceptorErrCb(error)
      }
      return Promise.reject(error)
    },
  )
}

export function configureKhetiAxiosInstance(config: KhetiAxiosConfig) {
  const {
    appCode,
    khetiUrl,
    requestInterceptorSuccessCb,
    requestInterceptorErrCb,
    responseInterceptorSuccessCb,
    responseInterceptorErrCb,
  } = config
  khetiAxiosInstance.defaults.baseURL = khetiUrl
  khetiAxiosInstance.defaults.headers.common['APP-CODE'] = appCode

  setUpInterceptors(
    khetiAxiosInstance,
    requestInterceptorSuccessCb,
    requestInterceptorErrCb,
    responseInterceptorSuccessCb,
    responseInterceptorErrCb,
  )
}
